var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgranelBrandLogotype(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 183,
    height: 38,
    viewBox: "0 0 183 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .LOGOTYPEcls-1 {\n        clip-path: url(#clip-AgranelBrandLogotype);\n      }\n\n      .LOGOTYPEcls-2 {\n        fill: #ea0000;\n      }\n\n      .LOGOTYPEcls-3 {\n        fill: #fff;\n      }\n\n      .LOGOTYPEcls-4 {\n        font-size: 36px;\n        font-family: Muli-Black, Muli;\n        font-weight: 800;\n        letter-spacing: 0.008em;\n        opacity: 0.88;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-AgranelBrandLogotype"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 183,
    height: 38
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AgranelBrandLogotype",
    className: "LOGOTYPEcls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "LOGOTYPEcls-3",
    width: 183,
    height: 38
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286",
    transform: "translate(-212 -39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    className: "LOGOTYPEcls-2",
    d: "M16,0h0A16,16,0,0,1,32,16V28.8A3.2,3.2,0,0,1,28.8,32H16A16,16,0,0,1,0,16v0A16,16,0,0,1,16,0Z",
    transform: "translate(212 39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_110",
    "data-name": "Rectangle 110",
    className: "LOGOTYPEcls-3",
    d: "M8,0H8a8,8,0,0,1,8,8v6.667A1.333,1.333,0,0,1,14.667,16H8A8,8,0,0,1,0,8V8A8,8,0,0,1,8,0Z",
    transform: "translate(220 47)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    className: "LOGOTYPEcls-2",
    d: "M5,0H5a5,5,0,0,1,5,5V9.167A.833.833,0,0,1,9.167,10H5A5,5,0,0,1,0,5V5A5,5,0,0,1,5,0Z",
    transform: "translate(223 50)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Agranel",
    className: "LOGOTYPEcls-4",
    transform: "translate(41 30)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Agranel")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgranelBrandLogotype);
export default __webpack_public_path__ + "static/media/AgranelBrandLogotype.9576ed4f8828adbb6b4db996cf507053.svg";
export { ForwardRef as ReactComponent };